<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>技术资料</el-breadcrumb-item>
                <!-- <el-breadcrumb-item>班组信息</el-breadcrumb-item> -->
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <p class="main-left-p">
                    <span>共有文件夹：{{folderList.length}}</span>
                    <el-button size="mini" type="text" @click="addEntFun" style="font-size:0.8vw;">添加文件夹</el-button>
                </p>
                <div class="main-left-list">
                    <ul>
                        <li v-for="(item,index) in folderList" :key="index" :class="{'curEnt':folderId==item.id}" @click="getEntId(item)">
                            <i class="el-icon-folder"></i>
                            <div class="unit-name color4">
                                <p :title="item.filesName" class="nowrap">{{item.filesName}}</p>
                            </div>
                            <div class="unit-ctl color4" style="width:40%;">
                                <el-button type="text" @click="editFolder(item)">编辑</el-button>
                                <el-button type="text" style="color:red;" @click="delFolder(item)">删除</el-button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="main-table">
                <div class="table-head">
                    <div class="table-head-seach">
                    </div>
                    <el-upload
                        class="upload-demo"
                        v-if="folderId!=''"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data={type:225}
                        :show-file-list="false"
                        :on-success="fileSuccess">
                        <el-button size="small" type="primary" class="primary">点击上传</el-button>
                    </el-upload>
                    <!-- <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addTeam">添加班组</el-button> -->
                </div>
                <div class="table-box">
                    <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column label="序号" type="index" width="80"></el-table-column>
                        <el-table-column label="文件名称">
                            <template slot-scope="scope">
                                <!--  <router-link :to="'/teamWorker/'+scope.row.id" class="color5" :title="scope.row.name">{{scope.row.name}}</router-link> -->
                                <div style="width:100%;height:100%;display:flex;align-items: center;justify-content: center;" @click="showFile(scope.row)">
                                    <img v-if="scope.row.fileFormat=='0'" src="../../assets/image/office/undefined.png" style="width:5vh;height:5vh;"  />
                                    <img v-else-if="scope.row.fileFormat=='1'" src="../../assets/image/office/word.png" style="width:5vh;height:5vh;" />
                                    <img v-else-if="scope.row.fileFormat=='2'" src="../../assets/image/office/excel.png" style="width:5vh;height:5vh;" />
                                    <img v-else-if="scope.row.fileFormat=='3'" src="../../assets/image/office/pdf.png" style="width:5vh;height:5vh;" />
                                    <img v-else-if="scope.row.fileFormat=='4'" src="../../assets/image/office/photo.png" style="width:5vh;height:5vh;" />
                                    <img v-else src="../../assets/image/office/undefined.png" style="width:5vh;height:5vh;" />
                                    <span style="padding-left:1vw;">{{scope.row.filesName}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="大小" width="200">
                            <template slot-scope="scope">
                            <span>{{ scope.row.filseCapacity }}B</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="上传日期" width="200">
                            <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="240">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="handleDown(scope.$index, scope.row)">下载</el-button>
                                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="30%"
        >
        <el-form
            :model="addFolder"
            ref="addFolder"
            :rules="rules"
            label-width="200px"
            label-position="right"
            class="joinEnt"
        >
            <el-form-item label="文件名：" prop="fileName">
                <el-input v-model="addFolder.filesName" autocomplete="off" style="width:220px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="entVisible = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
        </div>
        </el-dialog>
        <!-- 二维码弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
import vueQr from 'vue-qr'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            entName:'',//参建单位查询
            groupId:'',
            folderList:[],//参建单位list
            entsTypes:[],//参建单位类型list
            entTitle:'',//参建单位弹出框名称
            entVisible:false,
            persons:[],//参建单位的管理人员
            addFolder:{
                filesType:'1',
                type:'3',
                id: '',
                groupId: '',
                filesName:'',
                userType:''
            },
            rules: {
                filesName: [
                    { required: true, message: '请填写文件名称', trigger: 'blur' }
                ],
            },
            folderId:'',//当前展示文件夹id
            tableDataEnd:[],//班组列表
            diaTitle:'添加文件夹',//班组添加名称
            dataText: '数据加载中...',
            teamName:'',//班组名称
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
        }
    },
    mounted(){
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.getFolder()
        // this.getPerson()
    },
    methods:{
        //获取文件夹
        getFolder(){
            var that = this
            myHttp.selectFolder({
                filesType:'1',
                type:'3',
                groupId:this.groupId,
                userType:util.session.get('roleId')
            }).then(function(resp){
                if (resp.data.code == '200'){
                    var list = resp.data.data.Files || []
                    if(list.length>0){
                        that.folderId = list.length>0?list[0].id:''
                        that.getData()
                    }else{
                        that.dataText = '暂无数据'
                    }
                    that.folderList = list
                }else{

                }
            })
        },
        //添加参建单位
        addEntFun(){
            this.entVisible = true
            this.addFolder.filesName = ''
            this.addFolder.id = ''
            this.entTitle = '添加文件夹'
            
        },
        
        //添加或者修改文件夹
        sumbitAddFolder(formName){
            var that = this
            this.addFolder.createBy = util.session.get('user').id
            this.addFolder.groupId = this.groupId
            this.addFolder.userType = util.session.get('roleId')
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addFolder.id == '') {
                    myHttp.addFolderFiles(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateFiles(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        //选择展示的文件夹
        getEntId(row){
            this.folderId = row.id
            this.getData()
        },

        /***
         * 获取文件
         */
        getData(){
            var that = this
            // console.log(this.joinEntId)
            myHttp.selectDocumentNew({
                id:this.folderId,
                pageSize: 10000,
                pageNum: 1
            }).then(function(resp){
                if (resp.data.code == '200') {
                    var list = resp.data.data.Files.data || []
                    for(var i=0;i<list.length;i++){
                        list[i].fileFormat = list[i].filesName && list[i].filesName!=''?that.getImg(list[i].filesName):'0'
                    }
                    that.tableDataEnd = list
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        /**
         * 根据名称查询班组
         */
        doFilter(){
            this.getTeam()
        },
        /**
         * 添加班组
         */
        // addTeam(){
        //     this.addFormVisible = true
        //     // this.teamPersons = []
        //     this.getPerson()
        //     this.addForm = {
        //         id: '',
        //         name: '',
        //         teamsType: '1',
        //         creditCode: '',
        //         remarks: '',
        //         projectEntId: this.joinEntId,
        //         teamManager: '',
        //         managerTel: ''
        //     }
        //     this.diaTitle = '添加班组'
        // },
        //修改班组
        // handleEdit(index, row) {
        //     this.addFormVisible = true
        //     this.persons = []
        //     this.getPersonByTeam(row.id)
        //     this.addForm.id = row.id
        //     this.addForm.projectEntId = row.projectEntId
        //     this.addForm.name = row.name
        //     this.addForm.teamsType = row.teamsType
        //     this.addForm.creditCode = row.creditCode
        //     this.addForm.entName = row.entName
        //     this.addForm.entId = row.entId
        //     this.addForm.remarks = row.remarks
        //     this.addForm.teamManager = row.teamManager
        //     this.addForm.managerTel = row.managerTel
        //     this.addForm.joinTypeName = row.joinTypeName
        //     this.addForm.deviceSn = row.deviceSn
        //     this.diaTitle = '班组修改'
        // },
        //展示
        showFile(row){
            var that = this
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+row.filesAddress),"_blank");
        },
        //下载
        handleDown(index,row){
            window.open(base.httpCtx+row.filesAddress)
        },
        // 删除班组
        handleDelete(index, row) {
            var that = this
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteFiles({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message({
                        type: 'success',
                        message: '删除成功!'
                        })
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            }).catch(err => {})
        },
        //上传成功
        fileSuccess(res,file,opt){
            if(res.code==200){
                // console.log(res)
                // console.log(file)
                var obj = {
                    filesType:'2',
                    type:'3',
                    filesName:file.name,
                    filesAddress:res.data.saveUrls,
                    filseCapacity:file.size,
                    groupId:this.groupId,
                    userType:util.session.get('roleId'),
                    parentId:this.folderId,
                    createBy:util.session.get('user').id
                }
                var that = this
                myHttp.addFolderFiles(obj).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message.success('添加成功')
                        that.getData()
                    }else{
                        that.$message.error(resp.data.msg)
                    }
                })
            }else{
                this.$message.error(res.msg);
            }
            
        },
        //编辑文件夹
        editFolder(obj){
            this.entVisible = true
            this.addFolder.filesName = obj.filesName
            this.addFolder.id = obj.id
            
            this.entTitle = '修改文件夹'

        },
        //删除文件夹
        delFolder(obj){
            
            var that = this
            this.$confirm('此操作将永久删除该文件夹及其中的文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteFiles({
                    id: obj.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getFolder()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },

        //展示二维码
        erCode(index,row){
            this.codeVis = true
            this.codeUrl = base.httpCtx+row.filesAddress
            this.codeTit = row.filesName
        },
    }

}
</script>
<style scoped>
    
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
    }
    .main-left-search{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
    }
    .main-left-p{
        width: 100%;
        height: 7%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 85%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 5vh;
        position: relative;
        padding:1vh 2vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .curEnt i,.curEnt p{
        color: #5A87F9;
    }
    /* .unit-type{
        width: 20%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;
        border: 1px solid #0365F2;
        padding: 1.5%;
    } */
    .unit-name{
        width: 60%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2vh;
        justify-content: space-between;
    }
    .table-head-seach{
        width: 20%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-ent{
        width: 100%;
        height: 10vh;
        position: relative;
        margin-bottom: 1vh;
        background: #fff;
        border-radius: 5px;
        display: flex;
        /* flex-wrap: wrap; */
    }
    .box-ent-l{
        width: 80%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 2vh;
        align-content: center;
        align-items: center;
    }
    .box-ent-l p{
        width: 33%;
        height: 3vh;
        position: relative;
        text-align: left;
        padding-right: 1vh;
    }
    .box-ent-r{
        width: 20%;
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
    }
    
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
<style>
@import '../../assets/css/common.css';
</style>